/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedModelOfRealTimeActiveBindDto } from '../model/paginatedModelOfRealTimeActiveBindDto';
import { PaginatedModelOfSmppBindLog } from '../model/paginatedModelOfSmppBindLog';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmppActionService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param ip 
     * @param port 
     * @param systemId 
     * @param password 
     * @param systemType 
     * @param interfaceVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionCreateBind(ip?: string, port?: string, systemId?: string, password?: string, systemType?: string, interfaceVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppActionCreateBind(ip?: string, port?: string, systemId?: string, password?: string, systemType?: string, interfaceVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppActionCreateBind(ip?: string, port?: string, systemId?: string, password?: string, systemType?: string, interfaceVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppActionCreateBind(ip?: string, port?: string, systemId?: string, password?: string, systemType?: string, interfaceVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ip !== undefined && ip !== null) {
            queryParameters = queryParameters.set('ip', <any>ip);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (systemType !== undefined && systemType !== null) {
            queryParameters = queryParameters.set('systemType', <any>systemType);
        }
        if (interfaceVersion !== undefined && interfaceVersion !== null) {
            queryParameters = queryParameters.set('interfaceVersion', <any>interfaceVersion);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/smppaction/bindtoserver`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ipaddress 
     * @param port 
     * @param connectionstatusEnum 
     * @param directionOfConnectionEnum 
     * @param startDate 
     * @param endDate 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionGetAllBindLogs(ipaddress?: string, port?: string, connectionstatusEnum?: number, directionOfConnectionEnum?: number, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfSmppBindLog>;
    public smppActionGetAllBindLogs(ipaddress?: string, port?: string, connectionstatusEnum?: number, directionOfConnectionEnum?: number, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfSmppBindLog>>;
    public smppActionGetAllBindLogs(ipaddress?: string, port?: string, connectionstatusEnum?: number, directionOfConnectionEnum?: number, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfSmppBindLog>>;
    public smppActionGetAllBindLogs(ipaddress?: string, port?: string, connectionstatusEnum?: number, directionOfConnectionEnum?: number, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ipaddress !== undefined && ipaddress !== null) {
            queryParameters = queryParameters.set('ipaddress', <any>ipaddress);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (connectionstatusEnum !== undefined && connectionstatusEnum !== null) {
            queryParameters = queryParameters.set('connectionstatusEnum', <any>connectionstatusEnum);
        }
        if (directionOfConnectionEnum !== undefined && directionOfConnectionEnum !== null) {
            queryParameters = queryParameters.set('directionOfConnectionEnum', <any>directionOfConnectionEnum);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfSmppBindLog>(`${this.basePath}/api/smppaction/getallbindlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ip 
     * @param port 
     * @param systemId 
     * @param password 
     * @param from 
     * @param to 
     * @param text 
     * @param systemType 
     * @param interfaceVersion 
     * @param usecustomsubmitBuilder 
     * @param useonetimemessagesettings 
     * @param dataCoding 
     * @param udhi 
     * @param addressRange 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionSendDirectMessage(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppActionSendDirectMessage(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppActionSendDirectMessage(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppActionSendDirectMessage(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ip !== undefined && ip !== null) {
            queryParameters = queryParameters.set('ip', <any>ip);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', <any>text);
        }
        if (systemType !== undefined && systemType !== null) {
            queryParameters = queryParameters.set('systemType', <any>systemType);
        }
        if (interfaceVersion !== undefined && interfaceVersion !== null) {
            queryParameters = queryParameters.set('interfaceVersion', <any>interfaceVersion);
        }
        if (usecustomsubmitBuilder !== undefined && usecustomsubmitBuilder !== null) {
            queryParameters = queryParameters.set('usecustomsubmitBuilder', <any>usecustomsubmitBuilder);
        }
        if (useonetimemessagesettings !== undefined && useonetimemessagesettings !== null) {
            queryParameters = queryParameters.set('useonetimemessagesettings', <any>useonetimemessagesettings);
        }
        if (dataCoding !== undefined && dataCoding !== null) {
            queryParameters = queryParameters.set('dataCoding', <any>dataCoding);
        }
        if (udhi !== undefined && udhi !== null) {
            queryParameters = queryParameters.set('udhi', <any>udhi);
        }
        if (addressRange !== undefined && addressRange !== null) {
            queryParameters = queryParameters.set('addressRange', <any>addressRange);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/smppaction/senddirectmessage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ip 
     * @param port 
     * @param systemId 
     * @param password 
     * @param from 
     * @param to 
     * @param text 
     * @param systemType 
     * @param interfaceVersion 
     * @param usecustomsubmitBuilder 
     * @param useonetimemessagesettings 
     * @param dataCoding 
     * @param udhi 
     * @param addressRange 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionSendDirectMessageWithSingletonConnection(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppActionSendDirectMessageWithSingletonConnection(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppActionSendDirectMessageWithSingletonConnection(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppActionSendDirectMessageWithSingletonConnection(ip?: string, port?: string, systemId?: string, password?: string, from?: string, to?: string, text?: string, systemType?: string, interfaceVersion?: string, usecustomsubmitBuilder?: boolean, useonetimemessagesettings?: boolean, dataCoding?: number, udhi?: number, addressRange?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ip !== undefined && ip !== null) {
            queryParameters = queryParameters.set('ip', <any>ip);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }
        if (text !== undefined && text !== null) {
            queryParameters = queryParameters.set('text', <any>text);
        }
        if (systemType !== undefined && systemType !== null) {
            queryParameters = queryParameters.set('systemType', <any>systemType);
        }
        if (interfaceVersion !== undefined && interfaceVersion !== null) {
            queryParameters = queryParameters.set('interfaceVersion', <any>interfaceVersion);
        }
        if (usecustomsubmitBuilder !== undefined && usecustomsubmitBuilder !== null) {
            queryParameters = queryParameters.set('usecustomsubmitBuilder', <any>usecustomsubmitBuilder);
        }
        if (useonetimemessagesettings !== undefined && useonetimemessagesettings !== null) {
            queryParameters = queryParameters.set('useonetimemessagesettings', <any>useonetimemessagesettings);
        }
        if (dataCoding !== undefined && dataCoding !== null) {
            queryParameters = queryParameters.set('dataCoding', <any>dataCoding);
        }
        if (udhi !== undefined && udhi !== null) {
            queryParameters = queryParameters.set('udhi', <any>udhi);
        }
        if (addressRange !== undefined && addressRange !== null) {
            queryParameters = queryParameters.set('addressRange', <any>addressRange);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/smppaction/SendDirectMessageWithSingletonConnection`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param smsroutename 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionTestBindByRouteName(creatorId?: string, smsroutename?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppActionTestBindByRouteName(creatorId?: string, smsroutename?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppActionTestBindByRouteName(creatorId?: string, smsroutename?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppActionTestBindByRouteName(creatorId?: string, smsroutename?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (smsroutename !== undefined && smsroutename !== null) {
            queryParameters = queryParameters.set('smsroutename', <any>smsroutename);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/smppaction/testbindbysmsroutename`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ip 
     * @param port 
     * @param systemID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionUnBind(ip?: string, port?: number, systemID?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppActionUnBind(ip?: string, port?: number, systemID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppActionUnBind(ip?: string, port?: number, systemID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppActionUnBind(ip?: string, port?: number, systemID?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ip !== undefined && ip !== null) {
            queryParameters = queryParameters.set('ip', <any>ip);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (systemID !== undefined && systemID !== null) {
            queryParameters = queryParameters.set('systemID', <any>systemID);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/smppaction/unbindfromserver`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param bindGroupId 
     * @param hostIp 
     * @param port 
     * @param systemid 
     * @param bindCategoryEnumId 
     * @param connectionStatusEnumId 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppActionViewactiveBinds(bindGroupId?: string, hostIp?: string, port?: string, systemid?: string, bindCategoryEnumId?: number, connectionStatusEnumId?: number, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<PaginatedModelOfRealTimeActiveBindDto>;
    public smppActionViewactiveBinds(bindGroupId?: string, hostIp?: string, port?: string, systemid?: string, bindCategoryEnumId?: number, connectionStatusEnumId?: number, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedModelOfRealTimeActiveBindDto>>;
    public smppActionViewactiveBinds(bindGroupId?: string, hostIp?: string, port?: string, systemid?: string, bindCategoryEnumId?: number, connectionStatusEnumId?: number, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedModelOfRealTimeActiveBindDto>>;
    public smppActionViewactiveBinds(bindGroupId?: string, hostIp?: string, port?: string, systemid?: string, bindCategoryEnumId?: number, connectionStatusEnumId?: number, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (bindGroupId !== undefined && bindGroupId !== null) {
            queryParameters = queryParameters.set('bindGroupId', <any>bindGroupId);
        }
        if (hostIp !== undefined && hostIp !== null) {
            queryParameters = queryParameters.set('hostIp', <any>hostIp);
        }
        if (port !== undefined && port !== null) {
            queryParameters = queryParameters.set('port', <any>port);
        }
        if (systemid !== undefined && systemid !== null) {
            queryParameters = queryParameters.set('systemid', <any>systemid);
        }
        if (bindCategoryEnumId !== undefined && bindCategoryEnumId !== null) {
            queryParameters = queryParameters.set('bindCategoryEnumId', <any>bindCategoryEnumId);
        }
        if (connectionStatusEnumId !== undefined && connectionStatusEnumId !== null) {
            queryParameters = queryParameters.set('connectionStatusEnumId', <any>connectionStatusEnumId);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<PaginatedModelOfRealTimeActiveBindDto>(`${this.basePath}/api/smppaction/viewactivebinds`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
